import { ComponentProps } from 'react';
import { CurrentUser, useCurrentUser } from '../../contexts/CurrentUser';
import { SocialGraphPOC as SocialGraphV2 } from './SocialGraphPOC';
import { SocialGraphPOC as SocialGraphLegacy } from './legacy/SocialGraphPOC';

export const SOCIAL_GRAPH_V2_FLAG = 'social_graph_v2';

// Scaling Phase 1 (PR #1153) ships behind `social_graph_v2`. Workspaces without
// the flag keep the pre-Phase-1 graph (`legacy/` — frozen copies of the files
// the phase touched, sharing every other module with v2). Both still require the
// base `social_graph` flag, which each implementation checks itself.
export const hasSocialGraphV2 = (currentUser: CurrentUser | null | undefined): boolean =>
  Boolean(currentUser?.workspace?.config?.featureflags?.includes(SOCIAL_GRAPH_V2_FLAG));

export type SocialGraphProps = ComponentProps<typeof SocialGraphV2>;

export function SocialGraph(props: SocialGraphProps) {
  const [currentUser] = useCurrentUser();
  return hasSocialGraphV2(currentUser) ? <SocialGraphV2 {...props} /> : <SocialGraphLegacy {...props} />;
}
